{
  "enum": {
    "IxcRaglV1ManualEntryStatus": {
      "POSTED": "Posted",
      "REVERSED": "Reversed",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRaglV1PortfolioLinkPortfolioEvent": {
      "POSTED": "Posted",
      "SETTLED": "Settled",
      "SLATED": "Slated",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcRaglV1TransactionStatus": {
      "POSTED": "Posted",
      "REVERSED": "Reversed",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcRaglV1ManualEntryQueryServiceManualEntryListFilterableFields": {
      "data": {
        "assets": {
          "asset": {
            "assetId": "Asset",
            "data": {
              "category": "Asset Category",
              "type": {
                "!type": "Asset Type",
                "equity": {
                  "controls": {
                    "canBuy": "Equity: Can Buy",
                    "canEnterFractions": "Equity: Can Enter Fractions",
                    "canSell": "Equity: Can Sell"
                  },
                  "cusip": "Equity CUSIP"
                },
                "moneyMarket": {
                  "classification": "Money Market: Classification",
                  "controls": {
                    "canBuy": "Money Market: Can Buy",
                    "canEnterFractions": "Money Market: Can Enter Fractions",
                    "canSell": "Money Market: Can Sell"
                  },
                  "cusip": "Money Market CUSIP",
                  "navType": "Money Market: NAV Type"
                }
              }
            },
            "status": "Asset Status"
          }
        },
        "effectiveAt": "Effective At"
      },
      "entryId": "Entry",
      "status": "Status"
    },
    "IxcRaglV1ReportsServiceCashBlotterFilterableFields": {
      "accountCode": "Account Code",
      "asset": {
        "assetId": "Asset",
        "data": {
          "category": "Asset Category",
          "type": {
            "!type": "Asset Type",
            "equity": {
              "controls": {
                "canBuy": "Equity: Can Buy",
                "canEnterFractions": "Equity: Can Enter Fractions",
                "canSell": "Equity: Can Sell"
              },
              "cusip": "Equity CUSIP"
            },
            "moneyMarket": {
              "classification": "Money Market: Classification",
              "controls": {
                "canBuy": "Money Market: Can Buy",
                "canEnterFractions": "Money Market: Can Enter Fractions",
                "canSell": "Money Market: Can Sell"
              },
              "cusip": "Money Market CUSIP",
              "navType": "Money Market: NAV Type"
            }
          }
        },
        "status": "Asset Status"
      },
      "brokerageAccount": {
        "accountId": "Brokerage Account ID",
        "accountingGroup": "Accounting Group",
        "programCode": "Brokerage Account Program Code",
        "programId": "Brokerage Account Program",
        "purpose": "Account Purpose",
        "status": "Account Status",
        "sweepPlanId": "Account Sweep Plan"
      },
      "effectiveAt": "Effective At",
      "transactionId": "Transaction ID"
    },
    "IxcRaglV1ReportsServiceCustomerCashBalanceFilterableFields": {
      "account": {
        "accountId": "Account",
        "accountingGroup": "Accounting Group",
        "programCode": "Account Program Code",
        "programId": "Program",
        "purpose": "Account Purpose",
        "status": "Account Status",
        "sweepPlanId": "Account Sweep Plan"
      }
    },
    "IxcRaglV1ReportsServiceCustomerStockRecordFilterableFields": {
      "account": {
        "accountId": "Account",
        "accountingGroup": "Accounting Group",
        "programCode": "Account Program Code",
        "programId": "Program",
        "purpose": "Account Purpose",
        "status": "Account Status",
        "sweepPlanId": "Account Sweep Plan"
      },
      "asset": {
        "assetId": "Asset",
        "data": {
          "category": "Asset Category",
          "type": {
            "!type": "Asset Type",
            "equity": {
              "controls": {
                "canBuy": "Equity: Can Buy",
                "canEnterFractions": "Equity: Can Enter Fractions",
                "canSell": "Equity: Can Sell"
              },
              "cusip": "Equity CUSIP"
            },
            "moneyMarket": {
              "classification": "Money Market: Classification",
              "controls": {
                "canBuy": "Money Market: Can Buy",
                "canEnterFractions": "Money Market: Can Enter Fractions",
                "canSell": "Money Market: Can Sell"
              },
              "cusip": "Money Market CUSIP",
              "navType": "Money Market: NAV Type"
            }
          }
        },
        "status": "Asset Status"
      }
    },
    "IxcRaglV1ReportsServiceCustomerSweepRecordFilterableFields": {
      "account": {
        "accountId": "Account",
        "accountingGroup": "Accounting Group",
        "programCode": "Program Code",
        "programId": "Program",
        "purpose": "Account Purpose",
        "status": "Account Status",
        "sweepPlanId": "Sweep Plan"
      },
      "asset": {
        "assetId": "Asset",
        "data": {
          "category": "Asset Category",
          "type": {
            "!type": "Asset Type",
            "equity": {
              "controls": {
                "canBuy": "Equity: Can Buy",
                "canEnterFractions": "Equity: Can Enter Fractions",
                "canSell": "Equity: Can Sell"
              },
              "cusip": "Equity: CUSIP"
            },
            "moneyMarket": {
              "classification": "Money Market: Classification",
              "controls": {
                "canBuy": "Money Market: Controls Can Buy",
                "canEnterFractions": "Money Market: Controls Can Enter Fractions",
                "canSell": "Money Market: Controls Can Sell"
              },
              "cusip": "Money Market CUSIP",
              "navType": "Money Market NAV Type"
            }
          }
        },
        "status": "Asset Status"
      }
    },
    "IxcRaglV1ReportsServiceStockBlotterFilterableFields": {
      "accountCode": "Account Code",
      "asset": {
        "assetId": "Asset",
        "data": {
          "category": "Asset Category",
          "type": {
            "!type": "Asset Type",
            "equity": {
              "controls": {
                "canBuy": "Equity: Can Buy",
                "canEnterFractions": "Equity: Can Enter Fractions",
                "canSell": "Equity: Can Sell"
              },
              "cusip": "Equity CUSIP"
            },
            "moneyMarket": {
              "classification": "Money Market: Classification",
              "controls": {
                "canBuy": "Money Market: Can Buy",
                "canEnterFractions": "Money Market: Can Enter Fractions",
                "canSell": "Money Market: Can Sell"
              },
              "cusip": "Money Market CUSIP",
              "navType": "Money Market: NAV Type"
            }
          }
        },
        "status": "Asset Status"
      },
      "brokerageAccount": {
        "accountId": "Brokerage Account",
        "accountingGroup": "Accounting Group",
        "programCode": "Program Code",
        "programId": "Program",
        "purpose": "Account Purpose",
        "status": "Account Status",
        "sweepPlanId": "Sweep Plan"
      },
      "effectiveAt": "Effective At",
      "transactionId": "Transaction ID"
    },
    "IxcRaglV1TransactionQueryServiceTransactionListFilterableFields": {
      "data": {
        "assets": {
          "asset": {
            "assetId": "Asset",
            "data": {
              "category": "Asset Category",
              "type": {
                "!type": "Asset Type",
                "equity": {
                  "controls": {
                    "canBuy": "Equity: Can Buy",
                    "canEnterFractions": "Equity: Can Enter Fractions",
                    "canSell": "Equity: Can Sell"
                  },
                  "cusip": "Equity CUSIP"
                },
                "moneyMarket": {
                  "classification": "Money Market: Classification",
                  "controls": {
                    "canBuy": "Money Market: Can Buy",
                    "canEnterFractions": "Money Market: Can Enter Fractions",
                    "canSell": "Money Market: Can Sell"
                  },
                  "cusip": "Money Market CUSIP",
                  "navType": "Money Market: NAV Type"
                }
              }
            },
            "status": "Asset Status"
          }
        },
        "detail": {
          "!type": "Type"
        },
        "effectiveAt": "Effective At"
      },
      "status": "Status",
      "transactionId": "Transaction"
    }
  },
  "oneOf": {
    "IxcRaglV1DateOrTime": {
      "date": "Date",
      "time": "Time"
    },
    "IxcRaglV1ManualEntryEventType": {
      "posted": "Posted",
      "reversed": "Reversed"
    },
    "IxcRaglV1RegistrationType": {
      "platform": "Platform",
      "registration": "Registration"
    },
    "IxcRaglV1TransactionEventType": {
      "portfolioPosted": "Portfolio Posted",
      "portfolioSettled": "Portfolio Settled",
      "posted": "Posted",
      "reversed": "Reversed"
    }
  },
  "polymorph": {
    "IxcRaglV1TransactionDetail": {
      "exc": {
        "jpmam": {
          "v1": {
            "MoneyMarketTransaction": "Money Market"
          }
        }
      },
      "ixc": {
        "billing": {
          "v1": {
            "ChargeTransaction": "Charge",
            "CustomerChargeTransaction": "Customer Charge"
          }
        },
        "corpactions": {
          "caadmin": {
            "v1": {
              "DTCPaymentTransaction": "DTC Payment Transaction"
            }
          },
          "v1": {
            "CorpactionTransaction": "Corporate Action"
          }
        },
        "dtcc": {
          "cns": {
            "v1": {
              "SettlementTransaction": "Settlement"
            }
          }
        },
        "funding": {
          "v1": {
            "FundingBatchTransaction": "Funding Batch",
            "FundingTransaction": "Funding"
          }
        },
        "inventory": {
          "v1": {
            "CloseTradingDayTransaction": "Close Trading Day",
            "InventoryTradeTransaction": "Inventory Trade",
            "SettleTradingDayTransaction": "Settle Trading Day"
          }
        },
        "mutualfunds": {
          "v1": {
            "FundTransaction": "Fund Transaction"
          }
        },
        "orders": {
          "v1": {
            "BatchAllocationAvgPriceTransaction": "Batch Allocation Average Price",
            "BatchAllocationCustomerTransaction": "Batch Allocation Customer",
            "BatchRemainderInventoryTransaction": "Batch Remainder Inventory",
            "TradeTransaction": "Trade"
          }
        },
        "portfolio": {
          "v1": {
            "DividendPaymentTransaction": "Dividend"
          }
        },
        "ragl": {
          "v1": {
            "ManualTransaction": "Manual Entry"
          }
        },
        "sweeps": {
          "clearing": {
            "v1": {
              "SweepsTransaction": "Sweeps"
            }
          }
        },
        "trade": {
          "v1": {
            "NettingIndicationTransaction": "Netting Indication"
          }
        }
      }
    }
  },
  "searchEnum": {
    "IxcRaglV1ManualEntryQueryServiceManualEntryListSearchableFields": {
      "data": {
        "assets": {
          "asset": {
            "data": {
              "type": {
                "equity": {
                  "name": "Equity Name",
                  "symbol": {
                    "base": "Equity Symbol Base"
                  }
                },
                "moneyMarket": {
                  "name": "Money Market Name",
                  "symbol": {
                    "base": "Money Market Symbol Base"
                  }
                }
              }
            }
          }
        }
      }
    },
    "IxcRaglV1ReportsServiceCashBlotterSearchableFields": {
      "asset": {
        "data": {
          "type": {
            "equity": {
              "name": "Equity Name",
              "symbol": {
                "base": "Equity Symbol Base"
              }
            },
            "moneyMarket": {
              "name": "Money Market Name",
              "symbol": {
                "base": "Money Market Symbol Base"
              }
            }
          }
        }
      },
      "brokerageAccount": {
        "displayId": "Brokerage Account Display ID"
      }
    },
    "IxcRaglV1ReportsServiceCustomerCashBalanceSearchableFields": {
      "account": {
        "displayId": "Account Display ID"
      }
    },
    "IxcRaglV1ReportsServiceCustomerStockRecordSearchableFields": {
      "account": {
        "displayId": "Account Display ID"
      },
      "asset": {
        "data": {
          "type": {
            "equity": {
              "name": "Equity Name",
              "symbol": {
                "base": "Equity Symbol Base"
              }
            },
            "moneyMarket": {
              "name": "Money Market Name",
              "symbol": {
                "base": "Money Market Symbol Base"
              }
            }
          }
        }
      }
    },
    "IxcRaglV1ReportsServiceCustomerSweepRecordSearchableFields": {
      "account": {
        "displayId": "Account Display ID"
      },
      "asset": {
        "data": {
          "type": {
            "equity": {
              "name": "Asset Data Type Equity Name",
              "symbol": {
                "base": "Asset Data Type Equity Symbol Base"
              }
            },
            "moneyMarket": {
              "name": "Asset Data Type Money Market Name",
              "symbol": {
                "base": "Asset Data Type Money Market Symbol Base"
              }
            }
          }
        }
      }
    },
    "IxcRaglV1ReportsServiceStockBlotterSearchableFields": {
      "asset": {
        "data": {
          "type": {
            "equity": {
              "name": "Equity Name",
              "symbol": {
                "base": "Equity Symbol Base"
              }
            },
            "moneyMarket": {
              "name": "Money Market Name",
              "symbol": {
                "base": "Money Market Symbol Base"
              }
            }
          }
        }
      },
      "brokerageAccount": {
        "displayId": "Brokerage Account Display ID"
      }
    },
    "IxcRaglV1TransactionQueryServiceTransactionListSearchableFields": {
      "data": {
        "assets": {
          "asset": {
            "data": {
              "type": {
                "equity": {
                  "name": "Equity Name",
                  "symbol": {
                    "base": "Equity Symbol Base"
                  }
                },
                "moneyMarket": {
                  "name": "Money Market Name",
                  "symbol": {
                    "base": "Money Market Symbol Base"
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  "sortEnum": {
    "IxcRaglV1ManualEntryQueryServiceManualEntryListSortableFields": {
      "data": {
        "effectiveAt": "Effective At"
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcRaglV1ReportsServiceCashBlotterSortableFields": {
      "asset": {
        "metadata": {
          "createdAt": "Asset Created At",
          "updatedAt": "Asset Updated At"
        }
      },
      "effectiveAt": "Effective At"
    },
    "IxcRaglV1ReportsServiceCustomerStockRecordSortableFields": {
      "asset": {
        "metadata": {
          "createdAt": "Asset Created At",
          "updatedAt": "Asset Updated At"
        }
      }
    },
    "IxcRaglV1ReportsServiceCustomerSweepRecordSortableFields": {
      "asset": {
        "metadata": {
          "createdAt": "Asset Created At",
          "updatedAt": "Asset Updated At"
        }
      }
    },
    "IxcRaglV1ReportsServiceStockBlotterSortableFields": {
      "asset": {
        "metadata": {
          "createdAt": "Asset Created At",
          "updatedAt": "Asset Updated At"
        }
      },
      "effectiveAt": "Effective At"
    },
    "IxcRaglV1TransactionQueryServiceTransactionListSortableFields": {
      "data": {
        "effectiveAt": "Effective At"
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}